/* eslint-disable */
// ─────────────────────────────────────────────────────────────────────────────
// ErpFinanceiro.jsx — Página ERP Financeiro (Gestão de Recebíveis) IMOBMEET
// Transcrição fiel do bundle de produção (imobmeet-site.netlify.app).
// Componente original: lm(). Sub-componentes e mocks animados inline verbatim.
// Navbar e Footer são os componentes compartilhados do projeto.
// ─────────────────────────────────────────────────────────────────────────────
import * as b from "react";
import * as n from "react/jsx-runtime";
import { Link as V } from "react-router-dom";
import { C, font, mono } from "../tokens";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { applySeo } from "../lib/seo";
import { setFaqSchema, clearFaqSchema } from "../lib/faqSchema";

// Aliases dos identificadores do bundle original.
const s = C, p = font, Pt = mono;
const _n = Navbar;   // Navbar compartilhada
const Hn = Footer;   // Footer compartilhado
const qn = () => null;

function ki({
    videoId: e,
    open: t,
    onClose: r,
    title: o = "Vídeo",
    subtitle: i = "IMOBMEET CRM"
}) {
    return b.useEffect(() => {
        if (!t) return;
        const a = d => {
            d.key === "Escape" && r()
        };
        document.addEventListener("keydown", a);
        const l = document.body.style.overflow;
        return document.body.style.overflow = "hidden", () => {
            document.removeEventListener("keydown", a), document.body.style.overflow = l
        }
    }, [t, r]), t ? n.jsx("div", {
        onClick: r,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": o,
        style: {
            position: "fixed",
            inset: 0,
            zIndex: 200,
            background: "rgba(5,9,23,0.82)",
            backdropFilter: "blur(6px)",
            WebkitBackdropFilter: "blur(6px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
            animation: "notif-in 0.22s cubic-bezier(.16,1,.3,1) both"
        },
        children: n.jsxs("div", {
            onClick: a => a.stopPropagation(),
            style: {
                width: "100%",
                maxWidth: 980,
                borderRadius: 18,
                overflow: "hidden",
                background: "#0B1330",
                border: "1px solid rgba(255,255,255,0.12)",
                boxShadow: "0 40px 100px rgba(0,0,0,0.6)"
            },
            children: [n.jsxs("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: 13,
                    padding: "14px 16px 14px 18px",
                    borderBottom: "1px solid rgba(255,255,255,0.08)",
                    background: "linear-gradient(180deg, rgba(255,255,255,0.05), rgba(255,255,255,0))"
                },
                children: [n.jsx("span", {
                    style: {
                        width: 38,
                        height: 38,
                        borderRadius: 11,
                        flexShrink: 0,
                        background: "linear-gradient(135deg, #2C6BFF 0%, #0560FF 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 6px 16px rgba(5,96,255,0.4)"
                    },
                    children: n.jsxs("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "#fff",
                        strokeWidth: "1.9",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: [n.jsx("rect", {
                            x: "3",
                            y: "4",
                            width: "18",
                            height: "12",
                            rx: "2"
                        }), n.jsx("path", {
                            d: "M2 20h20"
                        }), n.jsx("path", {
                            d: "M10 8.5 14.5 11 10 13.5z",
                            fill: "#fff",
                            stroke: "none"
                        })]
                    })
                }), n.jsxs("div", {
                    style: {
                        flex: 1,
                        minWidth: 0
                    },
                    children: [n.jsx("div", {
                        style: {
                            fontFamily: p,
                            fontSize: 16,
                            fontWeight: 800,
                            color: "#fff",
                            letterSpacing: -.3,
                            lineHeight: 1.2
                        },
                        children: o
                    }), i && n.jsx("div", {
                        style: {
                            fontFamily: p,
                            fontSize: 12.5,
                            color: "rgba(255,255,255,0.55)",
                            marginTop: 1
                        },
                        children: i
                    })]
                }), n.jsx("button", {
                    onClick: r,
                    "aria-label": "Fechar vídeo",
                    style: {
                        width: 38,
                        height: 38,
                        borderRadius: 10,
                        flexShrink: 0,
                        background: "rgba(255,255,255,0.10)",
                        border: "1px solid rgba(255,255,255,0.18)",
                        color: "white",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "background 0.2s"
                    },
                    onMouseEnter: a => a.currentTarget.style.background = "rgba(255,255,255,0.2)",
                    onMouseLeave: a => a.currentTarget.style.background = "rgba(255,255,255,0.1)",
                    children: n.jsx("svg", {
                        width: "17",
                        height: "17",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "2.4",
                        strokeLinecap: "round",
                        children: n.jsx("path", {
                            d: "M18 6 6 18M6 6l12 12"
                        })
                    })
                })]
            }), n.jsxs("div", {
                style: {
                    position: "relative",
                    paddingTop: "56.25%",
                    background: "#000"
                },
                children: [n.jsx("iframe", {
                    src: `https://www.youtube-nocookie.com/embed/${e}?autoplay=1&rel=0&modestbranding=1&iv_load_policy=3&playsinline=1&fs=1`,
                    title: o,
                    allow: "autoplay; encrypted-media; picture-in-picture; web-share",
                    allowFullScreen: !0,
                    style: {
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        border: 0
                    }
                }), n.jsx("div", {
                    "aria-hidden": "true",
                    onClick: a => a.preventDefault(),
                    style: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        height: "18%",
                        zIndex: 2,
                        cursor: "default"
                    }
                })]
            }), n.jsxs("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 14,
                    flexWrap: "wrap",
                    padding: "15px 18px",
                    borderTop: "1px solid rgba(255,255,255,0.08)",
                    background: "linear-gradient(0deg, rgba(255,255,255,0.05), rgba(255,255,255,0))"
                },
                children: [n.jsx("span", {
                    style: {
                        fontFamily: p,
                        fontSize: 13.5,
                        color: "rgba(255,255,255,0.7)",
                        lineHeight: 1.4
                    },
                    children: "Quer ver aplicado à sua operação?"
                }), n.jsxs(V, {
                    to: "/agendar-demo",
                    onClick: r,
                    style: {
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 9,
                        padding: "12px 22px",
                        borderRadius: 11,
                        textDecoration: "none",
                        background: "linear-gradient(135deg, #2C6BFF 0%, #0560FF 100%)",
                        color: "#fff",
                        fontFamily: p,
                        fontSize: 14.5,
                        fontWeight: 800,
                        letterSpacing: .2,
                        boxShadow: "0 10px 24px rgba(5,96,255,0.4)",
                        transition: "transform 0.2s, box-shadow 0.2s"
                    },
                    onMouseEnter: a => {
                        a.currentTarget.style.transform = "translateY(-2px)", a.currentTarget.style.boxShadow = "0 14px 30px rgba(5,96,255,0.5)"
                    },
                    onMouseLeave: a => {
                        a.currentTarget.style.transform = "none", a.currentTarget.style.boxShadow = "0 10px 24px rgba(5,96,255,0.4)"
                    },
                    children: ["Falar com vendas", n.jsx("svg", {
                        width: "16",
                        height: "16",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "2.4",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: n.jsx("path", {
                            d: "M5 12h14M13 6l6 6-6 6"
                        })
                    })]
                })]
            })]
        })
    }) : null
}

function wi({
    children: e,
    style: t = {},
    dotColor: r = s.accent
}) {
    return n.jsxs("div", {
        style: {
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            background: s.accentLight,
            border: `1.5px solid ${s.accentBorder}`,
            borderRadius: 24,
            padding: "5px 14px 5px 10px",
            fontSize: 12,
            fontWeight: 700,
            color: s.accent,
            letterSpacing: .2,
            fontFamily: p,
            ...t
        },
        children: [n.jsx("span", {
            style: {
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: r,
                display: "inline-block",
                boxShadow: `0 0 0 3px ${r}1A`
            }
        }), e]
    })
}

function O({
    children: e,
    light: t = !1,
    style: r = {}
}) {
    return n.jsx("h2", {
        style: {
            fontFamily: p,
            fontSize: 42,
            fontWeight: 800,
            lineHeight: 1.08,
            letterSpacing: -1.4,
            color: t ? "white" : s.text,
            margin: 0,
            ...r
        },
        children: e
    })
}

function se({
    children: e,
    primary: t = !0,
    href: r,
    to: o,
    style: i = {}
}) {
    const a = {
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            padding: "13px 22px",
            borderRadius: 11,
            fontSize: 14,
            fontWeight: 700,
            textDecoration: "none",
            fontFamily: p,
            cursor: "pointer"
        },
        l = {
            ...a,
            background: s.accent,
            color: "white",
            border: "1.5px solid transparent",
            boxShadow: "0 8px 24px rgba(5,96,255,0.28), inset 0 1px 0 rgba(255,255,255,0.18)",
            ...i
        },
        d = {
            ...a,
            background: s.surface,
            color: s.primary,
            border: `1.5px solid ${s.primary}`,
            ...i
        },
        c = t ? n.jsxs("span", {
            style: {
                position: "relative",
                zIndex: 1,
                display: "inline-flex",
                alignItems: "center",
                gap: 8
            },
            children: [e, " ", n.jsx("span", {
                className: "arrow",
                children: "→"
            })]
        }) : e,
        u = t ? "cta-primary" : "cta-secondary",
        m = t ? l : d;
    return o ? n.jsx(V, {
        to: o,
        className: u,
        style: m,
        children: c
    }) : n.jsx("a", {
        href: r || "#",
        className: u,
        style: m,
        children: c
    })
}

function k({
    children: e,
    delay: t = 0,
    as: r = "div",
    style: o = {},
    className: i = "",
    ...a
}) {
    const l = b.useRef(null);
    b.useEffect(() => {
        const c = l.current;
        if (!c) return;
        const u = new IntersectionObserver(([m]) => {
            m.isIntersecting && (c.classList.add("is-in"), u.disconnect())
        }, {
            threshold: .12,
            rootMargin: "0px 0px -8% 0px"
        });
        return u.observe(c), () => u.disconnect()
    }, []);
    const d = t ? ` delay-${t}` : "";
    return n.jsx(r, {
        ref: l,
        className: `reveal${d} ${i}`,
        style: o,
        ...a,
        children: e
    })
}

function gp({
    src: e,
    alt: t,
    maxHeight: r = 460,
    glow: o = "blue",
    style: i = {}
}) {
    const a = {
        blue: "rgba(5,96,255,0.20)",
        deep: "rgba(32,68,147,0.22)",
        green: "rgba(16,185,129,0.18)",
        warm: "rgba(245,158,11,0.16)"
    };
    return n.jsxs("div", {
        className: "mockup-frame",
        style: {
            position: "relative",
            borderRadius: 18,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ...i
        },
        children: [n.jsx("div", {
            style: {
                position: "absolute",
                inset: -28,
                zIndex: 0,
                background: `radial-gradient(ellipse at center, ${a[o]||a.blue} 0%, transparent 65%)`,
                filter: "blur(30px)",
                pointerEvents: "none"
            }
        }), n.jsx("img", {
            src: e,
            alt: t,
            style: {
                width: "100%",
                maxHeight: r,
                objectFit: "contain",
                display: "block",
                position: "relative",
                zIndex: 1,
                filter: "drop-shadow(0 24px 60px rgba(5,96,255,0.18)) drop-shadow(0 6px 16px rgba(0,0,0,0.06))"
            }
        })]
    })
}

function mp({
    children: e,
    style: t = {}
}) {
    return n.jsxs("div", {
        style: {
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            fontFamily: p,
            fontSize: 15.5,
            fontWeight: 800,
            letterSpacing: .2,
            color: "rgba(10,15,30,0.8)",
            background: "#FFFFFF",
            border: `1px solid ${s.border}`,
            boxShadow: "0 6px 18px rgba(10,15,30,0.08)",
            padding: "7px 17px 7px 8px",
            borderRadius: 12,
            marginBottom: 18,
            ...t
        },
        children: [n.jsx("img", {
            src: "/assets/icon-imobmeet.png",
            alt: "IMOBMEET",
            width: "38",
            height: "38",
            style: {
                display: "block",
                borderRadius: 10
            }
        }), e]
    })
}

function Si({
    src: e,
    alt: t = "",
    ratio: r = "3 / 4",
    radius: o = 22,
    style: i = {}
}) {
    return n.jsxs("div", {
        style: {
            position: "relative",
            width: "100%",
            aspectRatio: r,
            borderRadius: o,
            overflow: "hidden",
            background: `linear-gradient(160deg, ${s.accent} 0%, ${s.primary} 100%)`,
            boxShadow: "0 24px 60px rgba(5,96,255,0.22)",
            ...i
        },
        children: [n.jsx("div", {
            style: {
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "rgba(255,255,255,0.45)"
            },
            children: n.jsxs("svg", {
                width: "84",
                height: "84",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.3",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [n.jsx("circle", {
                    cx: "12",
                    cy: "8",
                    r: "4"
                }), n.jsx("path", {
                    d: "M4 21c0-4 3.6-7 8-7s8 3 8 7"
                })]
            })
        }), e && n.jsx("img", {
            src: e,
            alt: t,
            loading: "lazy",
            onError: a => {
                a.currentTarget.style.display = "none"
            },
            style: {
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover"
            }
        })]
    })
}

const X0 = n.jsx("svg", {
    width: "22",
    height: "22",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: n.jsx("path", {
        d: "M5 12h14M13 6l6 6-6 6"
    })
});

function Ue(e, t) {
    if (typeof e != "string" || e[0] !== "#" || e.length < 7) return e;
    const r = parseInt(e.slice(1, 3), 16),
        o = parseInt(e.slice(3, 5), 16),
        i = parseInt(e.slice(5, 7), 16);
    return `rgba(${r},${o},${i},${t})`
}

const L0 = [{
        name: "Itaú",
        src: "/assets/banks/itau.png"
    }, {
        name: "Bradesco",
        src: "/assets/banks/bradesco.png"
    }, {
        name: "Santander",
        src: "/assets/banks/santander.png"
    }, {
        name: "BTG Pactual",
        src: "/assets/banks/btg.svg"
    }, {
        name: "Caixa",
        src: "/assets/banks/caixa.png"
    }, {
        name: "Banco BRB",
        src: "/assets/banks/brb.png"
    }, {
        name: "Banco Inter",
        src: "/assets/banks/inter.svg",
        maxH: 62
    }, {
        name: "Banco Safra",
        src: "/assets/banks/safra.png"
    }, {
        name: "Sicredi",
        src: "/assets/banks/sicredi.png"
    }, {
        name: "Sicoob",
        src: "/assets/banks/sicoob.png"
    }],
    B0 = [{
        label: "Boleto Automático",
        desc: "Emissão de boletos no automático.",
        icon: n.jsxs(n.Fragment, {
            children: [n.jsx("rect", {
                x: "3",
                y: "5",
                width: "18",
                height: "14",
                rx: "2"
            }), n.jsx("path", {
                d: "M7 9v6M10 9v6M13 9v6M16 9v6"
            })]
        })
    }, {
        label: "Correção automática",
        desc: "Juros e índices atualizados sozinhos.",
        icon: n.jsxs(n.Fragment, {
            children: [n.jsx("path", {
                d: "M21 12a9 9 0 1 1-3-6.7"
            }), n.jsx("path", {
                d: "M21 4v5h-5"
            })]
        })
    }, {
        label: "Régua de Cobrança",
        desc: "Lembretes no WhatsApp e e-mail.",
        icon: n.jsxs(n.Fragment, {
            children: [n.jsx("path", {
                d: "M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"
            }), n.jsx("path", {
                d: "M13.7 21a2 2 0 0 1-3.4 0"
            })]
        })
    }, {
        label: "Baixa Automática",
        desc: "Conciliação sem remessa manual.",
        icon: n.jsxs(n.Fragment, {
            children: [n.jsx("path", {
                d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
            }), n.jsx("path", {
                d: "M22 4 12 14.01l-3-3"
            })]
        })
    }, {
        label: "Dashboard ao vivo",
        desc: "Indicadores de recebíveis em tempo real.",
        icon: n.jsxs(n.Fragment, {
            children: [n.jsx("rect", {
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2"
            }), n.jsx("path", {
                d: "M7 15v-4M12 15V9M17 15v-6"
            })]
        })
    }];

function fp({
    background: e = s.surface,
    borderTop: t = !0
}) {
    return n.jsx("section", {
        style: {
            background: e,
            padding: "100px 28px",
            borderTop: t ? `1px solid ${s.border}` : "none"
        },
        children: n.jsxs("div", {
            style: {
                maxWidth: 1080,
                margin: "0 auto"
            },
            children: [n.jsxs("div", {
                className: "bank-header",
                style: {
                    display: "grid",
                    gridTemplateColumns: "0.78fr 1.22fr",
                    gap: 56,
                    alignItems: "center",
                    margin: "0 auto 56px"
                },
                children: [n.jsx(k, {
                    children: n.jsxs("div", {
                        style: {
                            position: "relative",
                            maxWidth: 340,
                            margin: "0 auto"
                        },
                        children: [n.jsx(Si, {
                            src: "/assets/people/gestor-recebiveis-mobile.jpg",
                            alt: "Gestor acompanhando os recebíveis no IMOBMEET",
                            ratio: "4 / 5",
                            radius: 26
                        }), n.jsxs("div", {
                            style: {
                                position: "absolute",
                                bottom: -20,
                                right: -18,
                                background: "white",
                                borderRadius: 16,
                                padding: "13px 16px",
                                boxShadow: "0 18px 44px rgba(15,32,66,0.16)",
                                display: "flex",
                                alignItems: "center",
                                gap: 11
                            },
                            children: [n.jsx("div", {
                                style: {
                                    width: 40,
                                    height: 40,
                                    borderRadius: 11,
                                    flexShrink: 0,
                                    background: "rgba(16,185,129,0.14)",
                                    color: "#10B981",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                },
                                children: n.jsx("svg", {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2.2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: n.jsx("path", {
                                        d: "M20 6 9 17l-5-5"
                                    })
                                })
                            }), n.jsxs("div", {
                                children: [n.jsx("div", {
                                    style: {
                                        fontFamily: p,
                                        fontWeight: 800,
                                        fontSize: 14.5,
                                        color: s.text
                                    },
                                    children: "Boleto conciliado"
                                }), n.jsx("div", {
                                    style: {
                                        fontFamily: p,
                                        fontSize: 12,
                                        color: s.muted
                                    },
                                    children: "automático, em tempo real"
                                })]
                            })]
                        })]
                    })
                }), n.jsx(k, {
                    delay: 1,
                    children: n.jsxs("div", {
                        children: [n.jsx(O, {
                            style: {
                                marginBottom: 16
                            },
                            children: "Gestão de Recebíveis completa integrada ao seu banco."
                        }), n.jsx("p", {
                            style: {
                                fontFamily: p,
                                fontSize: 17.5,
                                color: s.muted,
                                margin: 0,
                                lineHeight: 1.65,
                                maxWidth: 520
                            },
                            children: "Emissão de boletos unitários ou em lote, conciliação automática sem a necessidade de arquivos de remessa, retorno ou conciliação — integrado nativamente aos principais bancos que a sua operação já usa."
                        })]
                    })
                })]
            }), n.jsx("div", {
                style: {
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                    gap: 16
                },
                children: L0.map((r, o) => n.jsx(k, {
                    delay: o % 6 + 1,
                    children: n.jsx("div", {
                        className: "card",
                        style: {
                            background: s.surface,
                            border: `1px solid ${s.border}`,
                            borderRadius: 16,
                            padding: "24px 22px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: 96
                        },
                        children: n.jsx("img", {
                            src: r.src,
                            alt: r.name,
                            title: r.name,
                            loading: "lazy",
                            style: {
                                maxHeight: r.maxH || 40,
                                maxWidth: "100%",
                                width: "auto",
                                objectFit: "contain",
                                display: "block"
                            }
                        })
                    })
                }, r.name))
            }), n.jsx(k, {
                children: n.jsx("p", {
                    style: {
                        textAlign: "center",
                        fontFamily: p,
                        fontSize: 15.5,
                        fontWeight: 600,
                        color: s.muted,
                        margin: "30px 0 0"
                    },
                    children: "São mais de 30 bancos disponíveis."
                })
            }), n.jsx(k, {
                children: n.jsxs("div", {
                    style: {
                        marginTop: 76
                    },
                    children: [n.jsx("div", {
                        style: {
                            textAlign: "center",
                            marginBottom: 44
                        },
                        children: n.jsx("h3", {
                            style: {
                                fontFamily: p,
                                fontSize: 27,
                                fontWeight: 800,
                                letterSpacing: -.7,
                                color: s.text,
                                margin: "12px 0 0"
                            },
                            children: "Do boleto à baixa, sem trabalho manual"
                        })
                    }), n.jsxs("div", {
                        className: "recv2-timeline",
                        style: {
                            position: "relative",
                            display: "flex",
                            justifyContent: "space-between",
                            gap: 8,
                            maxWidth: 980,
                            margin: "0 auto"
                        },
                        children: [n.jsx("div", {
                            className: "recv2-line"
                        }), B0.map((r, o) => n.jsxs("div", {
                            style: {
                                position: "relative",
                                zIndex: 1,
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                textAlign: "center",
                                padding: "0 4px"
                            },
                            children: [n.jsxs("div", {
                                className: "recv2-node",
                                style: {
                                    position: "relative",
                                    width: 62,
                                    height: 62,
                                    borderRadius: "50%",
                                    flexShrink: 0,
                                    background: "linear-gradient(135deg, #0560FF, #204493)",
                                    color: "white",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginBottom: 16,
                                    boxShadow: "0 12px 26px rgba(5,96,255,0.30)",
                                    animation: `flow-pop 0.5s ease ${.15+o*.12}s both`
                                },
                                children: [n.jsx("svg", {
                                    width: "26",
                                    height: "26",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "1.9",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: r.icon
                                }), n.jsx("span", {
                                    style: {
                                        position: "absolute",
                                        top: -5,
                                        right: -5,
                                        width: 23,
                                        height: 23,
                                        borderRadius: "50%",
                                        background: "white",
                                        color: s.accent,
                                        border: `2px solid ${s.accent}`,
                                        fontFamily: p,
                                        fontSize: 11,
                                        fontWeight: 800,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: o + 1
                                })]
                            }), n.jsx("div", {
                                style: {
                                    fontFamily: p,
                                    fontSize: 14.5,
                                    fontWeight: 800,
                                    color: s.text,
                                    lineHeight: 1.3,
                                    maxWidth: 150
                                },
                                children: r.label
                            }), n.jsx("div", {
                                style: {
                                    fontFamily: p,
                                    fontSize: 12.5,
                                    color: s.muted,
                                    lineHeight: 1.45,
                                    marginTop: 5,
                                    maxWidth: 160
                                },
                                children: r.desc
                            })]
                        }, r.label))]
                    })]
                })
            }), n.jsx(k, {
                delay: 1,
                children: n.jsx("div", {
                    style: {
                        textAlign: "center",
                        marginTop: 48
                    },
                    children: n.jsx(se, {
                        to: "/agendar-demo",
                        children: "Agendar demonstração"
                    })
                })
            })]
        })
    })
}

function vr({
    tag: e,
    title: t,
    desc: r,
    bullets: o = [],
    shot: i,
    reverse: a = !1,
    accent: l = s.accent,
    pillBrand: d = !1
}) {
    return n.jsx("section", {
        style: {
            padding: "92px 28px",
            background: a ? s.bgAlt : s.surface
        },
        children: n.jsxs("div", {
            className: "feature-alt-grid",
            style: {
                maxWidth: 1180,
                margin: "0 auto",
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 64,
                alignItems: "center",
                direction: a ? "rtl" : "ltr"
            },
            children: [n.jsx("div", {
                style: {
                    direction: "ltr"
                },
                children: n.jsxs(k, {
                    children: [e && (d ? n.jsx(mp, {
                        children: e
                    }) : n.jsx(wi, {
                        dotColor: l,
                        style: {
                            marginBottom: 18,
                            color: l,
                            borderColor: Ue(l, .35),
                            background: Ue(l, .08)
                        },
                        children: e
                    })), n.jsx(O, {
                        style: {
                            marginBottom: 16
                        },
                        children: t
                    }), n.jsx("p", {
                        style: {
                            fontFamily: p,
                            fontSize: 17,
                            lineHeight: 1.7,
                            color: s.muted,
                            margin: "0 0 24px",
                            maxWidth: 520
                        },
                        children: r
                    }), n.jsx("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: 12
                        },
                        children: o.map((c, u) => n.jsxs("div", {
                            style: {
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 12
                            },
                            children: [n.jsx("span", {
                                style: {
                                    flexShrink: 0,
                                    width: 22,
                                    height: 22,
                                    borderRadius: 7,
                                    background: Ue(l, .12),
                                    color: l,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginTop: 1
                                },
                                children: n.jsx("svg", {
                                    width: "13",
                                    height: "13",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "3",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: n.jsx("path", {
                                        d: "M20 6 9 17l-5-5"
                                    })
                                })
                            }), n.jsx("span", {
                                style: {
                                    fontFamily: p,
                                    fontSize: 15.5,
                                    lineHeight: 1.5,
                                    color: s.text,
                                    fontWeight: 500
                                },
                                children: c
                            })]
                        }, u))
                    })]
                })
            }), n.jsx("div", {
                style: {
                    direction: "ltr"
                },
                children: n.jsx(k, {
                    delay: 2,
                    children: b.isValidElement(i) ? i : i && n.jsx(gp, {
                        src: i.src,
                        alt: i.alt,
                        glow: i.glow || "blue"
                    })
                })
            })]
        })
    })
}

function xp({
    tag: e,
    title: t,
    desc: r,
    items: o,
    columns: i = 3,
    accent: a = s.accent,
    dark: l = !1,
    pillBrand: d = !1
}) {
    return n.jsxs("section", {
        style: {
            padding: "100px 28px",
            background: l ? "#08102A" : s.bgAlt,
            position: "relative",
            overflow: "hidden"
        },
        children: [l && n.jsx("div", {
            className: "grid-bg-dark",
            style: {
                position: "absolute",
                inset: 0,
                opacity: .4
            }
        }), n.jsxs("div", {
            style: {
                maxWidth: 1180,
                margin: "0 auto",
                position: "relative"
            },
            children: [n.jsx(k, {
                children: n.jsxs("div", {
                    style: {
                        textAlign: "center",
                        maxWidth: 720,
                        margin: "0 auto 56px"
                    },
                    children: [e && (d ? n.jsx(mp, {
                        children: e
                    }) : n.jsx(wi, {
                        dotColor: a,
                        style: {
                            marginBottom: 16,
                            color: a,
                            borderColor: Ue(a, .35),
                            background: Ue(a, .08)
                        },
                        children: e
                    })), n.jsx(O, {
                        light: l,
                        style: {
                            marginBottom: 14
                        },
                        children: t
                    }), r && n.jsx("p", {
                        style: {
                            fontFamily: p,
                            fontSize: 17,
                            lineHeight: 1.65,
                            color: l ? "rgba(255,255,255,0.66)" : s.muted,
                            margin: 0
                        },
                        children: r
                    })]
                })
            }), n.jsx("div", {
                className: "feature-cards-grid",
                style: {
                    display: "grid",
                    gridTemplateColumns: `repeat(${i}, 1fr)`,
                    gap: 20
                },
                children: o.map((c, u) => n.jsx(k, {
                    delay: u % i + 1,
                    children: n.jsxs("div", {
                        className: "card",
                        style: {
                            background: l ? "rgba(255,255,255,0.03)" : s.surface,
                            border: `1px solid ${l?"rgba(255,255,255,0.08)":s.border}`,
                            borderRadius: 18,
                            padding: 28,
                            height: "100%"
                        },
                        children: [n.jsx("div", {
                            style: {
                                width: 46,
                                height: 46,
                                borderRadius: 12,
                                marginBottom: 18,
                                background: Ue(a, l ? .16 : .1),
                                color: a,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            },
                            children: c.icon || X0
                        }), n.jsx("h3", {
                            style: {
                                fontFamily: p,
                                fontSize: 18,
                                fontWeight: 800,
                                letterSpacing: -.4,
                                color: l ? "white" : s.text,
                                margin: "0 0 8px"
                            },
                            children: c.title
                        }), n.jsx("p", {
                            style: {
                                fontFamily: p,
                                fontSize: 14.5,
                                lineHeight: 1.6,
                                color: l ? "rgba(255,255,255,0.62)" : s.muted,
                                margin: 0
                            },
                            children: c.desc
                        })]
                    })
                }, u))
            })]
        })]
    })
}

function Ei({
    items: e,
    tag: t = "Perguntas frequentes",
    title: r = "Tudo que você precisa saber",
    id: o = "faq"
}) {
    const [i, a] = b.useState(0);
    return n.jsx("section", {
        id: o,
        style: {
            padding: "100px 28px",
            background: s.bgAlt
        },
        children: n.jsxs("div", {
            style: {
                maxWidth: 820,
                margin: "0 auto"
            },
            children: [n.jsx(k, {
                children: n.jsxs("div", {
                    style: {
                        textAlign: "center",
                        marginBottom: 48
                    },
                    children: [t && n.jsx(wi, {
                        style: {
                            marginBottom: 16
                        },
                        children: t
                    }), n.jsx(O, {
                        children: r
                    })]
                })
            }), n.jsx("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 12
                },
                children: e.map((l, d) => n.jsxs("div", {
                    className: `faq-item card ${i===d?"open":""}`,
                    style: {
                        background: s.surface,
                        border: `1px solid ${i===d?s.accentBorder:s.border}`,
                        borderRadius: 14,
                        overflow: "hidden"
                    },
                    children: [n.jsxs("button", {
                        className: "faq-question",
                        onClick: () => a(i === d ? -1 : d),
                        style: {
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 16,
                            padding: "20px 22px",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            textAlign: "left",
                            fontFamily: p,
                            fontSize: 16,
                            fontWeight: 700,
                            color: s.text
                        },
                        children: [n.jsx("span", {
                            children: l.q
                        }), n.jsx("span", {
                            className: "faq-icon",
                            style: {
                                flexShrink: 0,
                                width: 26,
                                height: 26,
                                borderRadius: "50%",
                                background: i === d ? s.accent : s.bgAlt,
                                color: i === d ? "white" : s.muted,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: 18,
                                fontWeight: 500
                            },
                            children: "+"
                        })]
                    }), n.jsx("div", {
                        className: "faq-body",
                        children: n.jsx("div", {
                            children: n.jsx("p", {
                                style: {
                                    fontFamily: p,
                                    fontSize: 15,
                                    lineHeight: 1.65,
                                    color: s.muted,
                                    margin: 0,
                                    padding: "0 22px 22px"
                                },
                                children: l.a
                            })
                        })
                    })]
                }, d))
            })]
        })
    })
}

function Fi({
    title: e = "Pronto para vender mais e gerenciar melhor?",
    subtitle: t = "Agende uma demonstração e veja o IMOBMEET aplicado à realidade da sua operação.",
    accent: r = s.accent,
    primary: o = {
        label: "Agendar demonstração",
        to: "/agendar-demo"
    },
    secondary: i,
    perks: a = ["Setup rápido", "Sem fidelidade longa", "Suporte dedicado"]
}) {
    return n.jsxs("section", {
        id: "demo",
        style: {
            position: "relative",
            overflow: "hidden",
            padding: "104px 28px",
            background: `linear-gradient(120deg, ${s.primary} 0%, ${r} 100%)`
        },
        children: [n.jsx("div", {
            className: "grid-bg-dark",
            style: {
                position: "absolute",
                inset: 0,
                opacity: .4
            }
        }), n.jsx("div", {
            className: "drift-soft",
            style: {
                position: "absolute",
                top: -120,
                left: "12%",
                width: 360,
                height: 360,
                borderRadius: "50%",
                background: "radial-gradient(circle, rgba(255,255,255,0.18), transparent 65%)",
                pointerEvents: "none"
            }
        }), n.jsx("div", {
            className: "drift-soft",
            style: {
                position: "absolute",
                bottom: -160,
                right: "10%",
                width: 420,
                height: 420,
                borderRadius: "50%",
                background: "radial-gradient(circle, rgba(255,255,255,0.12), transparent 65%)",
                pointerEvents: "none"
            }
        }), n.jsx("div", {
            style: {
                maxWidth: 720,
                margin: "0 auto",
                position: "relative",
                textAlign: "center"
            },
            children: n.jsxs(k, {
                children: [n.jsx("h2", {
                    style: {
                        fontFamily: p,
                        fontSize: 44,
                        fontWeight: 800,
                        letterSpacing: -1.4,
                        lineHeight: 1.08,
                        color: "white",
                        margin: "0 0 16px"
                    },
                    children: e
                }), n.jsx("p", {
                    style: {
                        fontFamily: p,
                        fontSize: 18,
                        lineHeight: 1.6,
                        color: "rgba(255,255,255,0.85)",
                        margin: "0 0 32px"
                    },
                    children: t
                }), n.jsxs("div", {
                    style: {
                        display: "flex",
                        gap: 12,
                        justifyContent: "center",
                        flexWrap: "wrap"
                    },
                    children: [n.jsx(se, {
                        to: o.to,
                        href: o.href,
                        style: {
                            background: "white",
                            color: s.primary,
                            boxShadow: "0 8px 24px rgba(0,0,0,0.18)"
                        },
                        children: o.label
                    }), i && n.jsx(se, {
                        primary: !1,
                        to: i.to,
                        href: i.href,
                        style: {
                            background: "transparent",
                            color: "white",
                            borderColor: "rgba(255,255,255,0.6)"
                        },
                        children: i.label
                    })]
                }), a && a.length > 0 && n.jsx("div", {
                    style: {
                        display: "flex",
                        gap: 24,
                        justifyContent: "center",
                        flexWrap: "wrap",
                        marginTop: 28
                    },
                    children: a.map(l => n.jsxs("span", {
                        style: {
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 7,
                            fontFamily: p,
                            fontSize: 13.5,
                            color: "rgba(255,255,255,0.8)",
                            fontWeight: 600
                        },
                        children: [n.jsx("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "3",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: n.jsx("path", {
                                d: "M20 6 9 17l-5-5"
                            })
                        }), l]
                    }, l))
                })]
            })
        })]
    })
}

const J0 = [{
    n: 1,
    label: "Boleto emitido",
    sub: "R$ 4.250,00 · venc. 10/07",
    color: "#0560FF",
    icon: n.jsxs(n.Fragment, {
        children: [n.jsx("rect", {
            x: "3",
            y: "5",
            width: "18",
            height: "14",
            rx: "2"
        }), n.jsx("path", {
            d: "M7 9v6M10 9v6M13 9v6M16 9v6"
        })]
    })
}, {
    n: 2,
    label: "Cliente notificado",
    sub: "WhatsApp + e-mail",
    color: "#25D366",
    icon: n.jsx("path", {
        d: "M21 11.5a8.38 8.38 0 0 1-8.5 8.5 8.5 8.5 0 0 1-4-1L3 21l1.9-5.5a8.5 8.5 0 1 1 16.1-4z"
    })
}, {
    n: 3,
    label: "Conciliação automática",
    sub: "sem necessidade de envio de remessa",
    color: "#10B981",
    icon: n.jsxs(n.Fragment, {
        children: [n.jsx("path", {
            d: "M12 1v22"
        }), n.jsx("path", {
            d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
        })]
    })
}];

function Z0() {
    return n.jsxs("div", {
        style: {
            background: s.surface,
            border: `1px solid ${s.border}`,
            borderRadius: 22,
            padding: 26,
            boxShadow: "0 24px 60px rgba(10,15,30,0.10)",
            maxWidth: 440,
            margin: "0 auto"
        },
        children: [n.jsxs("div", {
            style: {
                position: "relative",
                borderRadius: 16,
                border: `1px solid ${s.border}`,
                background: s.bgAlt,
                padding: "18px 18px 16px",
                marginBottom: 24,
                overflow: "hidden"
            },
            children: [n.jsxs("div", {
                style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    marginBottom: 14
                },
                children: [n.jsxs("div", {
                    children: [n.jsx("div", {
                        style: {
                            fontFamily: p,
                            fontSize: 11,
                            fontWeight: 800,
                            letterSpacing: .6,
                            textTransform: "uppercase",
                            color: s.muted
                        },
                        children: "Boleto bancário"
                    }), n.jsx("div", {
                        style: {
                            fontFamily: p,
                            fontSize: 24,
                            fontWeight: 800,
                            letterSpacing: -.6,
                            color: s.text,
                            marginTop: 3
                        },
                        children: "R$ 4.250,00"
                    })]
                }), n.jsxs("span", {
                    className: "bflow-badge",
                    style: {
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                        fontFamily: p,
                        fontSize: 12,
                        fontWeight: 800,
                        color: "#0560FF",
                        background: "#EAF1FF",
                        border: "1px solid #B8D0FF",
                        padding: "5px 11px",
                        borderRadius: 999
                    },
                    children: [n.jsx("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "3",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: n.jsx("path", {
                            d: "M20 6 9 17l-5-5"
                        })
                    }), "Emitido"]
                })]
            }), n.jsx("div", {
                style: {
                    display: "flex",
                    gap: 2,
                    alignItems: "flex-end",
                    height: 44
                },
                children: [3, 1, 2, 1, 4, 1, 1, 3, 2, 1, 1, 2, 4, 1, 2, 1, 3, 1, 1, 2, 1, 4, 2, 1, 1, 3, 1, 2, 1, 4, 1, 1, 2, 3, 1, 2, 1, 1, 4, 2, 1, 3, 1, 2, 1, 1].map((e, t) => n.jsx("span", {
                    style: {
                        width: e,
                        height: "100%",
                        background: t % 5 === 0 ? "#0A1230" : "#1f2733",
                        opacity: t % 3 === 0 ? .9 : .7,
                        borderRadius: 1
                    }
                }, t))
            }), n.jsx("div", {
                style: {
                    fontFamily: "monospace",
                    fontSize: 11,
                    color: s.muted,
                    marginTop: 10,
                    letterSpacing: 1
                },
                children: "34191.79001 01043.510047 91020.150008 8 92660000425000"
            })]
        }), n.jsxs("div", {
            style: {
                position: "relative",
                display: "flex",
                flexDirection: "column",
                gap: 12
            },
            children: [n.jsx("div", {
                style: {
                    position: "absolute",
                    left: 24,
                    top: 24,
                    bottom: 24,
                    width: 2,
                    background: s.border,
                    borderRadius: 2
                },
                children: n.jsx("div", {
                    className: "bflow-fill",
                    style: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        background: "#0560FF",
                        borderRadius: 2
                    }
                })
            }), J0.map(e => n.jsxs("div", {
                className: `bflow-row-${e.n}`,
                style: {
                    position: "relative",
                    zIndex: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: 14,
                    background: s.surface,
                    border: `1px solid ${s.border}`,
                    borderRadius: 14,
                    padding: "12px 14px"
                },
                children: [n.jsxs("span", {
                    style: {
                        position: "relative",
                        width: 48,
                        height: 48,
                        borderRadius: 13,
                        flexShrink: 0,
                        background: `${e.color}14`,
                        color: e.color,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    },
                    children: [n.jsx("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "1.9",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: e.icon
                    }), n.jsx("span", {
                        className: `bflow-check-${e.n}`,
                        style: {
                            position: "absolute",
                            right: -5,
                            bottom: -5,
                            width: 21,
                            height: 21,
                            borderRadius: "50%",
                            background: "#10B981",
                            color: "white",
                            border: "2px solid #fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        },
                        children: n.jsx("svg", {
                            width: "11",
                            height: "11",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "4",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: n.jsx("path", {
                                d: "M20 6 9 17l-5-5"
                            })
                        })
                    })]
                }), n.jsxs("div", {
                    style: {
                        flex: 1,
                        minWidth: 0
                    },
                    children: [n.jsx("div", {
                        style: {
                            fontFamily: p,
                            fontSize: 15.5,
                            fontWeight: 800,
                            color: s.text,
                            letterSpacing: -.2
                        },
                        children: e.label
                    }), n.jsx("div", {
                        style: {
                            fontFamily: p,
                            fontSize: 13,
                            color: s.muted,
                            marginTop: 1
                        },
                        children: e.sub
                    })]
                })]
            }, e.n))]
        })]
    })
}

const Ld = [{
        from: "me",
        type: "text",
        text: "Oi! Preciso da 2ª via do meu boleto 🙏",
        time: "09:41"
    }, {
        from: "biz",
        type: "text",
        text: "Claro! Já estou gerando a 2ª via aqui pra você 👍",
        time: "09:41",
        typingBefore: 1100
    }, {
        from: "biz",
        type: "doc",
        name: "Boleto-Julho.pdf",
        meta: "PDF · R$ 4.250,00 · vence 10/07",
        time: "09:41",
        typingBefore: 1300
    }, {
        from: "biz",
        type: "text",
        text: "Pode pagar pelo código de barras ou Pix. Assim que cair, a baixa é automática ✅",
        time: "09:42",
        typingBefore: 1200
    }, {
        from: "me",
        type: "text",
        text: "Perfeito, muito obrigado! 🙌",
        time: "09:42"
    }],
    em = "#25D366",
    tm = "#075E54",
    nm = "#DCF8C6",
    rm = "#ECE5DD";

function om() {
    const [e, t] = b.useState(0), [r, o] = b.useState(!1);
    b.useEffect(() => {
        let a = [],
            l = !1;
        const d = (u, m) => a.push(setTimeout(() => {
            l || u()
        }, m));

        function c() {
            t(0), o(!1);
            let u = 700;
            Ld.forEach((m, g) => {
                m.typingBefore && (d(() => o(!0), u), u += m.typingBefore), d(() => {
                    o(!1), t(g + 1)
                }, u), u += 1400
            }), d(c, u + 2400)
        }
        return c(), () => {
            l = !0, a.forEach(clearTimeout)
        }
    }, []);
    const i = () => n.jsxs("svg", {
        width: "16",
        height: "11",
        viewBox: "0 0 18 12",
        fill: "none",
        style: {
            marginLeft: 4,
            flexShrink: 0
        },
        children: [n.jsx("path", {
            d: "M1 6.5 4 9.5 9.5 3",
            stroke: "#34B7F1",
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }), n.jsx("path", {
            d: "M6.5 6.5 9.5 9.5 15 3",
            stroke: "#34B7F1",
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })]
    });
    return n.jsxs("div", {
        style: {
            width: "100%",
            maxWidth: 360,
            margin: "0 auto",
            borderRadius: 26,
            overflow: "hidden",
            background: rm,
            border: "1px solid rgba(10,15,30,0.10)",
            boxShadow: "0 26px 60px rgba(10,15,30,0.18)",
            fontFamily: p
        },
        children: [n.jsxs("div", {
            style: {
                background: tm,
                color: "white",
                display: "flex",
                alignItems: "center",
                gap: 11,
                padding: "13px 14px"
            },
            children: [n.jsx("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2.2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                style: {
                    opacity: .9
                },
                children: n.jsx("path", {
                    d: "M15 18l-6-6 6-6"
                })
            }), n.jsx("span", {
                style: {
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    background: "#fff",
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: n.jsx("img", {
                    src: "/assets/icon-imobmeet.png",
                    alt: "IMOBMEET",
                    width: "40",
                    height: "40",
                    style: {
                        borderRadius: "50%"
                    }
                })
            }), n.jsxs("div", {
                style: {
                    flex: 1,
                    minWidth: 0
                },
                children: [n.jsx("div", {
                    style: {
                        fontSize: 15,
                        fontWeight: 700,
                        lineHeight: 1.2
                    },
                    children: "IMOBMEET · Financeiro"
                }), n.jsx("div", {
                    style: {
                        fontSize: 11.5,
                        opacity: .85
                    },
                    children: r ? "digitando…" : "online"
                })]
            }), n.jsxs("svg", {
                width: "19",
                height: "19",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                style: {
                    opacity: .9
                },
                children: [n.jsx("path", {
                    d: "M23 7l-7 5 7 5V7z"
                }), n.jsx("rect", {
                    x: "1",
                    y: "5",
                    width: "15",
                    height: "14",
                    rx: "2"
                })]
            }), n.jsx("svg", {
                width: "19",
                height: "19",
                viewBox: "0 0 24 24",
                fill: "currentColor",
                style: {
                    opacity: .9
                },
                children: n.jsx("path", {
                    d: "M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a1 1 0 0 0-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66a1 1 0 0 0 .24-1.02c-.37-1.11-.56-2.3-.56-3.53a1 1 0 0 0-1-1H4.19a1 1 0 0 0-1 1C3.19 13.28 10.72 20.8 19.81 20.8a1 1 0 0 0 1-1v-3.42a1 1 0 0 0-1-1z"
                })
            })]
        }), n.jsxs("div", {
            style: {
                height: 430,
                padding: "16px 12px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                gap: 8,
                overflow: "hidden",
                backgroundImage: "radial-gradient(rgba(10,15,30,0.04) 1px, transparent 1px)",
                backgroundSize: "18px 18px"
            },
            children: [Ld.slice(0, e).map((a, l) => {
                const d = a.from === "me";
                return n.jsx("div", {
                    className: "chat-msg",
                    style: {
                        display: "flex",
                        justifyContent: d ? "flex-end" : "flex-start"
                    },
                    children: n.jsxs("div", {
                        style: {
                            maxWidth: "82%",
                            background: d ? nm : "#fff",
                            borderRadius: 12,
                            borderTopRightRadius: d ? 3 : 12,
                            borderTopLeftRadius: d ? 12 : 3,
                            padding: a.type === "doc" ? 8 : "8px 11px 6px",
                            boxShadow: "0 1px 1px rgba(10,15,30,0.10)"
                        },
                        children: [a.type === "doc" ? n.jsxs("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                                padding: "6px 6px 6px 4px",
                                minWidth: 220
                            },
                            children: [n.jsx("span", {
                                style: {
                                    width: 42,
                                    height: 42,
                                    borderRadius: 9,
                                    flexShrink: 0,
                                    background: "#FDECEC",
                                    color: "#E03E3E",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                },
                                children: n.jsxs("svg", {
                                    width: "22",
                                    height: "22",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "1.8",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [n.jsx("path", {
                                        d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                                    }), n.jsx("path", {
                                        d: "M14 2v6h6"
                                    })]
                                })
                            }), n.jsxs("div", {
                                style: {
                                    flex: 1,
                                    minWidth: 0
                                },
                                children: [n.jsx("div", {
                                    style: {
                                        fontSize: 13.5,
                                        fontWeight: 700,
                                        color: "#0A1230",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    },
                                    children: a.name
                                }), n.jsx("div", {
                                    style: {
                                        fontSize: 11.5,
                                        color: "#5E6E8A",
                                        marginTop: 1
                                    },
                                    children: a.meta
                                })]
                            }), n.jsx("span", {
                                style: {
                                    width: 26,
                                    height: 26,
                                    borderRadius: "50%",
                                    background: "#EAF1FF",
                                    color: "#0560FF",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0
                                },
                                children: n.jsx("svg", {
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2.2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: n.jsx("path", {
                                        d: "M12 3v12M7 10l5 5 5-5M5 21h14"
                                    })
                                })
                            })]
                        }) : n.jsx("span", {
                            style: {
                                fontSize: 14.5,
                                lineHeight: 1.4,
                                color: "#0A1230"
                            },
                            children: a.text
                        }), n.jsxs("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                gap: 2,
                                marginTop: 3
                            },
                            children: [n.jsx("span", {
                                style: {
                                    fontSize: 10.5,
                                    color: "#8696a0"
                                },
                                children: a.time
                            }), d && n.jsx(i, {})]
                        })]
                    })
                }, l)
            }), r && n.jsx("div", {
                className: "chat-msg",
                style: {
                    display: "flex",
                    justifyContent: "flex-start"
                },
                children: n.jsx("div", {
                    style: {
                        background: "#fff",
                        borderRadius: 12,
                        borderTopLeftRadius: 3,
                        padding: "12px 14px",
                        boxShadow: "0 1px 1px rgba(10,15,30,0.10)",
                        display: "flex",
                        gap: 4
                    },
                    children: [0, 1, 2].map(a => n.jsx("span", {
                        className: "chat-dot",
                        style: {
                            width: 7,
                            height: 7,
                            borderRadius: "50%",
                            background: "#9aa6b2",
                            animationDelay: `${a*.18}s`
                        }
                    }, a))
                })
            })]
        }), n.jsxs("div", {
            style: {
                background: "#F0F0F0",
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: "9px 10px"
            },
            children: [n.jsx("div", {
                style: {
                    flex: 1,
                    background: "#fff",
                    borderRadius: 999,
                    padding: "9px 14px",
                    fontSize: 13,
                    color: "#9aa6b2"
                },
                children: "Mensagem"
            }), n.jsx("span", {
                style: {
                    width: 38,
                    height: 38,
                    borderRadius: "50%",
                    background: em,
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0
                },
                children: n.jsx("svg", {
                    width: "18",
                    height: "18",
                    viewBox: "0 0 24 24",
                    fill: "currentColor",
                    children: n.jsx("path", {
                        d: "M2 21l21-9L2 3v7l15 2-15 2z"
                    })
                })
            })]
        })]
    })
}

const ir = "#0560FF",
    im = "sES9gShbygY",
    Re = e => n.jsx("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: e
    }),
    am = [{
        title: "Régua de cobrança",
        desc: "Lembretes automáticos até o pagamento.",
        icon: Re(n.jsxs(n.Fragment, {
            children: [n.jsx("path", {
                d: "M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"
            }), n.jsx("path", {
                d: "M13.7 21a2 2 0 0 1-3.4 0"
            })]
        }))
    }, {
        title: "Contas a pagar",
        desc: "Fornecedores, despesas e agendamentos.",
        icon: Re(n.jsxs(n.Fragment, {
            children: [n.jsx("rect", {
                x: "2",
                y: "5",
                width: "20",
                height: "14",
                rx: "2"
            }), n.jsx("path", {
                d: "M2 10h20"
            }), n.jsx("path", {
                d: "M6 15h4"
            })]
        }))
    }, {
        title: "Centro de Custo",
        desc: "Classifique cada lançamento por centro.",
        icon: Re(n.jsxs(n.Fragment, {
            children: [n.jsx("path", {
                d: "M3 3v18h18"
            }), n.jsx("rect", {
                x: "7",
                y: "12",
                width: "3",
                height: "6"
            }), n.jsx("rect", {
                x: "13",
                y: "8",
                width: "3",
                height: "10"
            })]
        }))
    }, {
        title: "Integração bancária",
        desc: "Mais de 30 bancos conectados.",
        icon: Re(n.jsxs(n.Fragment, {
            children: [n.jsx("path", {
                d: "M3 10 12 4l9 6"
            }), n.jsx("path", {
                d: "M5 10v9M19 10v9M9 10v9M15 10v9"
            }), n.jsx("path", {
                d: "M3 20h18"
            })]
        }))
    }, {
        title: "Conciliação automática",
        desc: "Baixa sem envio de remessa manual.",
        icon: Re(n.jsxs(n.Fragment, {
            children: [n.jsx("path", {
                d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
            }), n.jsx("path", {
                d: "M22 4 12 14.01l-3-3"
            })]
        }))
    }, {
        title: "Desdobramento de título",
        desc: "Divida e reparcela títulos.",
        icon: Re(n.jsxs(n.Fragment, {
            children: [n.jsx("path", {
                d: "M6 3v12a3 3 0 0 0 3 3h6"
            }), n.jsx("circle", {
                cx: "6",
                cy: "18",
                r: "3"
            }), n.jsx("circle", {
                cx: "18",
                cy: "18",
                r: "3"
            })]
        }))
    }, {
        title: "Correção automática",
        desc: "Juros e índices aplicados sozinhos.",
        icon: Re(n.jsxs(n.Fragment, {
            children: [n.jsx("path", {
                d: "M21 12a9 9 0 1 1-3-6.7"
            }), n.jsx("path", {
                d: "M21 4v5h-5"
            })]
        }))
    }, {
        title: "Índice automático",
        desc: "INCC, IPCA e IGP-M atualizados.",
        icon: Re(n.jsxs(n.Fragment, {
            children: [n.jsx("path", {
                d: "M3 17l6-6 4 4 8-8"
            }), n.jsx("path", {
                d: "M17 7h4v4"
            })]
        }))
    }, {
        title: "Dashboard",
        desc: "Indicadores de recebíveis em tempo real.",
        icon: Re(n.jsxs(n.Fragment, {
            children: [n.jsx("rect", {
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2"
            }), n.jsx("path", {
                d: "M7 15v-4M12 15V9M17 15v-6"
            })]
        }))
    }, {
        title: "Relatórios",
        desc: "Extratos e relatórios financeiros.",
        icon: Re(n.jsxs(n.Fragment, {
            children: [n.jsx("path", {
                d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
            }), n.jsx("path", {
                d: "M14 2v6h6M8 13h8M8 17h5"
            })]
        }))
    }, {
        title: "Boleto Split",
        desc: "Divisão do boleto entre as partes.",
        icon: Re(n.jsxs(n.Fragment, {
            children: [n.jsx("path", {
                d: "M6 3v6a3 3 0 0 0 3 3h6a3 3 0 0 1 3 3v6"
            }), n.jsx("circle", {
                cx: "6",
                cy: "3",
                r: "0"
            }), n.jsx("path", {
                d: "M3 6l3-3 3 3M15 18l3 3 3-3"
            })]
        }))
    }, {
        title: "Boletos em Lote",
        desc: "Emita centenas de boletos de uma vez.",
        icon: Re(n.jsxs(n.Fragment, {
            children: [n.jsx("rect", {
                x: "7",
                y: "7",
                width: "14",
                height: "14",
                rx: "2"
            }), n.jsx("path", {
                d: "M3 15V5a2 2 0 0 1 2-2h10"
            })]
        }))
    }],
    sm = [{
        q: "A gestão de recebíveis fica dentro do CRM?",
        a: "Sim. Toda a gestão financeira e o controle da carteira de recebíveis acontecem 100% dentro do CRM de vendas do IMOBMEET — sem planilha paralela e sem trocar de sistema. Cada recebimento fica ligado à venda que o originou."
    }, {
        q: "Como funciona a emissão e a baixa de boletos?",
        a: "Você emite boletos direto no CRM e dá baixa com controle total. O envio é automatizado por e-mail e WhatsApp, e o cliente tem uma central de 2ª via no WhatsApp para reemitir quando precisar — reduzindo inadimplência sem esforço manual."
    }, {
        q: "Com quais bancos vocês integram?",
        a: "Integramos com mais de 30 bancos, tradicionais e digitais, sem necessidade de envio de remessa. A conciliação é automática. Entre em contato para conhecer o melhor caminho para a sua operação de Gestão de Recebíveis."
    }, {
        q: "O que é o Split de Comissões?",
        a: "Com o Split de comissões do IMOBMEET você distribui comissões de maneira simples e inteligente, com o envio de pagamentos direto na conta de cada integrante — eliminando a bitributação."
    }];

function lm() {
    const [e, t] = b.useState(!1);
    return n.jsxs("div", {
        style: {
            background: s.surface,
            minHeight: "100vh",
            overflowX: "clip"
        },
        children: [n.jsx(_n, {
            activeSolution: "/gestao-de-recebiveis"
        }), n.jsxs("section", {
            id: "hero",
            style: {
                position: "relative",
                overflow: "hidden",
                minHeight: "min(720px, 92vh)",
                display: "flex",
                alignItems: "center",
                padding: "140px 28px 110px"
            },
            children: [n.jsx("video", {
                autoPlay: !0,
                muted: !0,
                loop: !0,
                playsInline: !0,
                poster: "/assets/crm-hero.jpg",
                "aria-hidden": "true",
                style: {
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    pointerEvents: "none"
                },
                children: n.jsx("source", {
                    src: "/assets/gestao-de-recebiveis-erp-financeiro.mp4",
                    type: "video/mp4"
                })
            }), n.jsx("div", {
                style: {
                    position: "absolute",
                    inset: 0,
                    pointerEvents: "none",
                    background: "linear-gradient(180deg, rgba(8,16,42,0.82) 0%, rgba(8,16,42,0.68) 45%, rgba(8,16,42,0.88) 100%)"
                }
            }), n.jsx("div", {
                style: {
                    position: "absolute",
                    inset: 0,
                    pointerEvents: "none",
                    background: "radial-gradient(ellipse 70% 60% at 50% 45%, transparent 0%, rgba(8,16,42,0.55) 100%)"
                }
            }), n.jsxs("div", {
                style: {
                    position: "relative",
                    zIndex: 3,
                    maxWidth: 820,
                    margin: "0 auto",
                    textAlign: "center"
                },
                children: [n.jsx(k, {
                    children: n.jsxs("div", {
                        style: {
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 12,
                            padding: "10px 29px 10px 11px",
                            marginBottom: 26,
                            background: "#FFFFFF",
                            border: "1px solid rgba(10,15,30,0.08)",
                            borderRadius: 14,
                            boxShadow: "0 10px 28px rgba(8,16,42,0.18)",
                            fontFamily: p,
                            fontSize: 19,
                            fontWeight: 800,
                            color: "rgba(10,15,30,0.8)",
                            letterSpacing: .2
                        },
                        children: [n.jsx("span", {
                            style: {
                                width: 60,
                                height: 60,
                                borderRadius: 15,
                                flexShrink: 0,
                                background: "linear-gradient(135deg, #0560FF, #204493)",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            },
                            children: n.jsxs("svg", {
                                width: "36",
                                height: "36",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "1.8",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [n.jsx("rect", {
                                    x: "2",
                                    y: "5",
                                    width: "20",
                                    height: "14",
                                    rx: "2"
                                }), n.jsx("path", {
                                    d: "M2 10h20"
                                }), n.jsx("path", {
                                    d: "M6 15h4"
                                })]
                            })
                        }), "Financeiro · Gestão de Recebíveis"]
                    })
                }), n.jsx(k, {
                    delay: 1,
                    children: n.jsxs("h1", {
                        style: {
                            fontFamily: p,
                            fontSize: "clamp(38px, 5.6vw, 58px)",
                            fontWeight: 800,
                            lineHeight: 1.04,
                            letterSpacing: -1.8,
                            color: "white",
                            margin: "0 0 22px",
                            textShadow: "0 2px 30px rgba(8,16,42,0.4)"
                        },
                        children: ["Sua gestão de vendas", n.jsx("br", {}), "100% integrada à ", n.jsx("span", {
                            style: {
                                color: "#7FB6FF"
                            },
                            children: "Gestão de Recebíveis"
                        })]
                    })
                }), n.jsx(k, {
                    delay: 2,
                    children: n.jsx("p", {
                        style: {
                            fontFamily: p,
                            fontSize: 19,
                            color: "rgba(255,255,255,0.9)",
                            lineHeight: 1.6,
                            margin: "0 auto 38px",
                            maxWidth: 660
                        },
                        children: "Gestão financeira, controle da carteira, emissão de boletos e cobrança automática — tudo dentro do seu CRM de vendas. Menos inadimplência, mais caixa, sem boleto feito na mão."
                    })
                }), n.jsx(k, {
                    delay: 3,
                    children: n.jsxs("div", {
                        style: {
                            display: "flex",
                            gap: 14,
                            flexWrap: "wrap",
                            justifyContent: "center"
                        },
                        children: [n.jsxs("button", {
                            onClick: () => t(!0),
                            style: {
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 12,
                                padding: "14px 28px 14px 14px",
                                borderRadius: 12,
                                background: "rgba(255,255,255,0.12)",
                                backdropFilter: "blur(8px)",
                                border: "1.5px solid rgba(255,255,255,0.35)",
                                fontFamily: p,
                                fontSize: 16,
                                fontWeight: 700,
                                color: "white",
                                cursor: "pointer",
                                transition: "background 0.2s, transform 0.2s"
                            },
                            onMouseEnter: r => {
                                r.currentTarget.style.background = "rgba(255,255,255,0.2)", r.currentTarget.style.transform = "translateY(-2px)"
                            },
                            onMouseLeave: r => {
                                r.currentTarget.style.background = "rgba(255,255,255,0.12)", r.currentTarget.style.transform = "none"
                            },
                            children: [n.jsx("span", {
                                style: {
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                    background: "white",
                                    color: s.accent,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0
                                },
                                children: n.jsx("svg", {
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor",
                                    children: n.jsx("path", {
                                        d: "M8 5v14l11-7z"
                                    })
                                })
                            }), "Assistir Vídeo"]
                        }), n.jsx(se, {
                            to: "/agendar-demo",
                            children: "Fale com vendas"
                        })]
                    })
                })]
            })]
        }), n.jsx(fp, {
            borderTop: !1
        }), n.jsx(xp, {
            accent: ir,
            pillBrand: !0,
            tag: "Como funciona",
            title: "O módulo de Gestão de Recebíveis",
            desc: "Tudo o que sua operação precisa para receber em dia, do controle da carteira à cobrança automática — sem sair do CRM.",
            items: am,
            columns: 4
        }), n.jsx(vr, {
            accent: ir,
            pillBrand: !0,
            tag: "Controle total",
            title: "Emissão de boletos e conciliação automática",
            desc: "A Gestão de Recebíveis no IMOBMEET CRM traz o controle que você precisa, com a praticidade que você sempre desejou. Emissão, envio, baixa automática e cobrança, em um só lugar.",
            bullets: ["Emissão de boletos dentro do próprio CRM", "Baixa Automática", "Conciliação automática", "Notificação por e-mail e WhatsApp", "Central de 2ª via no WhatsApp para o cliente"],
            shot: n.jsx(Z0, {})
        }), n.jsx(vr, {
            accent: ir,
            reverse: !0,
            pillBrand: !0,
            tag: "Central do cliente",
            title: "2ª via de boleto direto no WhatsApp",
            desc: "O cliente pede a segunda via pelo WhatsApp e recebe o boleto na hora, automaticamente — sem acionar o seu time. Menos ligação, menos atrito e mais boleto pago no prazo.",
            bullets: ["2ª via de boleto sob demanda, 24 horas por dia", "Envio automático do PDF, código de barras e Pix", "Lembretes e régua de cobrança pelo WhatsApp", "Menos chamados no seu atendimento"],
            shot: n.jsx(om, {})
        }), n.jsx(vr, {
            accent: ir,
            pillBrand: !0,
            tag: "Split de comissões",
            title: "Split de Comissões, elimine a bitributação",
            desc: "Com o Split de comissões do IMOBMEET, você distribui comissões de maneira simples e inteligente, com o envio de pagamentos direto na conta de cada integrante — sem bitributação.",
            bullets: ["Distribuição automática de comissões", "Pagamento direto na conta de cada integrante", "Elimina a bitributação da operação", "Tudo conectado às vendas do CRM"],
            shot: {
                src: "/assets/split-de-comissoes.png",
                alt: "Split de comissões",
                glow: "blue"
            }
        }), n.jsx(Ei, {
            items: sm,
            tag: null
        }), n.jsx(Fi, {
            accent: ir,
            perks: !1,
            title: "A solução ideal para organizar sua gestão de recebíveis",
            subtitle: "A jornada de vendas completa da sua incorporadora ou loteadora de maneira amigável, robusta e ágil, 100% digital.",
            primary: {
                label: "Agende uma demonstração",
                to: "/agendar-demo"
            }
        }), n.jsx(Hn, {}), n.jsx(qn, {}), n.jsx(ki, {
            open: e,
            onClose: () => t(!1),
            videoId: im,
            title: "IMOBMEET em ação"
        })]
    })
}

export default function ErpFinanceiro() {
    b.useEffect(() => {
        applySeo({
            title: "Gestão de Recebíveis para Incorporadoras e Loteadoras | IMOBMEET",
            description: "Gestão de recebíveis integrada ao CRM: boletos em lote, conciliação com +30 bancos, régua de cobrança no WhatsApp e split de comissões.",
            keywords: "gestão de recebíveis, emissão de boletos imobiliário, conciliação bancária, régua de cobrança, cobrança WhatsApp, split de comissões, ERP financeiro imobiliário",
            path: "/gestao-de-recebiveis"
        });
        setFaqSchema(sm);
        window.scrollTo(0, 0);
        return () => clearFaqSchema();
    }, []);
    return n.jsx(lm, {})
}
